/**
 * Extracts a YouTube video ID from common URL formats.
 * Returns null if the URL is not a recognised YouTube URL.
 */
export function extractYouTubeId(url) {
  if (!url) return null
  const patterns = [
    /(?:youtube\.com\/watch\?.*v=)([a-zA-Z0-9_-]{11})/,
    /(?:youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    /(?:youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
  ]
  for (const pattern of patterns) {
    const match = url.match(pattern)
    if (match && match[1]) return match[1]
  }
  return null
}

/**
 * Converts a YouTube URL to an embed URL with autoplay.
 * Returns null if the URL is invalid.
 */
export function toEmbedUrl(url) {
  const id = extractYouTubeId(url)
  if (!id) return null
  return `https://www.youtube.com/embed/${id}?autoplay=1`
}
